import React, { useContext, useEffect, useState } from "react";
import { Input, Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { msgEnum } from "../../config";
import {
  updateAccountInfo,
  resetaccountInfo,
} from "../../actionCreator/commonActionCreator";
import { AuthContext } from "../../context/AuthContext";

const Info = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useContext(AuthContext);
  const [errorObj, setError] = useState();
  const userAccountInfo = useSelector(
    (state) => state?.CommonReducer?.accountInfo,
  );
  // const subscriptionaccountInfo = useSelector(
  //   (state) => state?.CommonReducer?.subscriptionaccountInfo
  // );
  const usageAccountInfo = useSelector(
    (state) => state?.CommonReducer?.usageaccountInfo,
  );
  const formIntialValue = {
    phone: {
      disabled: false,
      value: usageAccountInfo?.subscriptions?.account?.phoneNo,
      status: null,
    },
    company: {
      disabled: false,
      value: usageAccountInfo?.subscriptions?.account?.company,
      status: null,
    },
    title: {
      disabled: false,
      value: usageAccountInfo?.subscriptions?.account?.designation,
      status: null,
    },
    firstname: {
      disabled: false,
      value: userAccountInfo?.firstName ? userAccountInfo?.firstName : "",
      status: null,
    },
    lastname: {
      disabled: false,
      value: userAccountInfo?.lastName ? userAccountInfo?.lastName : "",
      status: null,
    },
    email: { disabled: false, value: userAccountInfo?.email, status: null },
    mobile: {
      disabled: false,
      value: usageAccountInfo?.subscriptions?.account?.mobileNo,
      status: null,
    },
  };
  const [successMsg, setSuccessMsg] = useState("");
  const [form, setForm] = useState(formIntialValue);
  const updateaccountInfo = useSelector(
    (state) => state?.CommonReducer?.updateaccountInfo,
  );
  useEffect(() => {
    //console.log(userAccountInfo,'userAccountInfo')
    setForm(formIntialValue);
  }, [userAccountInfo]);

  useEffect(() => {
    if (Object.keys(updateaccountInfo).length) {
      //console.log("update account...")
      setSuccessMsg(msgEnum.PROFILE_UPDATE_MSG);
      setForm(formIntialValue);
      dispatch(resetaccountInfo());
    }
  }, [updateaccountInfo]);

  const onInputChange = (ele) => {
    setForm({
      ...form,
      [ele.target.name]: { ...form[ele.target.name], value: ele.target.value },
    });
  };

  const updateSettings = () => {
    // console.log(form,'formform');
    let payload = userAccountInfo;
    payload.firstName = form.firstname.value;
    payload.lastName = form.lastname.value;
    payload.designation = form.title.value;
    payload.email = form.email.value;
    payload.phoneNo = form.phone.value;
    payload.company = form.company.value;
    payload.mobileNo = form.mobile.value;
    let errObj = {};
    if (!payload?.firstName) {
      errObj = {
        ...errObj,
        firstname: "Please enter first name.",
      };
    }
    if (!payload?.lastName) {
      errObj = {
        ...errObj,
        lastname: "Please enter last name.",
      };
    }
    if (!payload?.email) {
      errObj = {
        ...errObj,
        email: "Please enter email.",
      };
    }
    // if (!payload?.title) {
    //   errObj = {
    //     ...errObj,
    //     title: "Please enter designation.",
    //   };
    // }
    setError(errObj);
    if (!Object.keys(errObj).length) {
      //console.log(payload,'payload',errObj)
      dispatch(updateAccountInfo(isAuthenticated, payload));
    }
  };

  return (
    <>
      <div style={{ marginLeft: 25 }} className="errorformcontainer mt-3">
        <div
          style={{
            marginBottom: 20,
            textAlign: "center",
            verticalAlign: "center",
          }}
        >
          <span style={{ color: "#02AA02", fontSize: 18 }}>{successMsg}</span>
        </div>
        {/* <span>{successMsg}</span> */}

        <div className="form">
          <div className="formcol1">First Name *</div>
          <div className="formcol2">
            <Input
              name="firstname"
              value={form?.firstname?.value}
              placeholder="First Name"
              onChange={onInputChange}
            />
            <div className="errorTxt">{errorObj?.firstname}</div>
          </div>
        </div>
        <div className="form">
          <div className="formcol1">Last Name *</div>
          <div className="formcol2">
            <Input
              name="lastname"
              value={form?.lastname?.value}
              placeholder="Last Name"
              onChange={onInputChange}
            />
            <div className="errorTxt">{errorObj?.lastname}</div>
          </div>
        </div>
        <div className="form">
          <div className="formcol1">Designation</div>
          <div className="formcol2">
            <Input
              name="title"
              value={form?.title?.value}
              placeholder="Designation"
              onChange={onInputChange}
            />
            {/* <div className="errorTxt">{errorObj?.title}</div>  */}
          </div>
        </div>

        <div className="form">
          <div className="formcol1">Phone</div>
          <div className="formcol2">
            <Input
              name="phone"
              value={form?.phone?.value}
              placeholder="Phone"
              status=""
              onChange={onInputChange}
            />
          </div>
        </div>

        <div className="form">
          <div className="formcol1">Mobile</div>
          <div className="formcol2">
            <Input
              name="mobile"
              value={form?.mobile?.value}
              placeholder="Mobile"
              onChange={onInputChange}
            />
          </div>
        </div>

        <div className="form">
          <div className="formcol1">Email *</div>
          <div className="formcol2">
            <Input
              name="email"
              value={form?.email?.value}
              placeholder="Email"
              onChange={onInputChange}
            />
            <div className="errorTxt">{errorObj?.email}</div>
          </div>
        </div>

        <div className="form">
          <div className="formcol1">Company Name</div>
          <div className="formcol2">
            <Input
              name="company"
              value={form?.company?.value}
              placeholder="Company Name"
              onChange={onInputChange}
            />
          </div>
        </div>

        <div className="mt-3 mb-3">
          <span className="mt-3 mr-3">
            {" "}
            <Button className="btn-info" type="primary" onClick="">
              Cancel
            </Button>
          </span>
          <span className="mt-3 mr-3">
            <Button
              className="btn-info"
              type="primary"
              onClick={updateSettings}
            >
              Save
            </Button>
          </span>
        </div>
      </div>
    </>
  );
};
export default Info;
